<template>
  <div></div>
</template>

<script>
import { UserManager } from 'oidc-client';
export default {
  name: 'CallBack',
  beforeMount() {
    new UserManager({ response_mode: 'query' })
      .signinRedirectCallback()
      .then(function() {
        let oldPath = window.sessionStorage.getItem('oldPath');
        window.sessionStorage.removeItem('oldPath');
        window.location = oldPath ? oldPath : '/';
      })
      .catch(function(e) {
        console.error(e);
      });
  },
};
</script>

<style scoped />
